export interface ChatThread {
    id: string;
    title: string;
    lastMessage: string;
    timestamp: string;
    unread: boolean;
}

export interface Shortcut {
    text: string;
    action: string;
    highlighted: boolean;
    icon?: string;
}

export interface AgentAction {
    id: string;
    title: string;
    description: string;
    actionText: string;
}

// Mock data for chat threads
export const chatThreads: ChatThread[] = [
    {
        id: '1',
        title: 'Zielplanung',
        lastMessage: 'Lass uns deine Q4 Ziele überprüfen...',
        timestamp: '2 min ago',
        unread: true,
    },
    {
        id: '2',
        title: 'Skill Assessment',
        lastMessage: 'Deine JavaScript Skills haben sich verbessert!',
        timestamp: '1 hour ago',
        unread: false,
    },
    {
        id: '3',
        title: 'Team Feedback',
        lastMessage: 'Hier ist die Team Performance Zusammenfassung...',
        timestamp: 'Yesterday',
        unread: false,
    },
    {
        id: '4',
        title: 'Projektplanung',
        lastMessage: 'Ich habe einen Vorschlag für die Ressourcenverteilung im neuen Projekt.',
        timestamp: '3 days ago',
        unread: false,
    },
    /*     {
        id: "5",
        title: "Karriereentwicklung",
        lastMessage: "Basierend auf deinen Skills empfehle ich folgende Weiterbildungen...",
        timestamp: "Last week",
        unread: true,
    }, */
    {
        id: '6',
        title: 'Lernpfad',
        lastMessage: 'Ich empfehle dir diese Kurse...',
        timestamp: '2 days ago',
        unread: false,
    },
    {
        id: '7',
        title: 'Zielplanung',
        lastMessage: 'Lass uns deine Q4 Ziele überprüfen...',
        timestamp: '2 min ago',
        unread: false,
    },
];

// Shortcuts
export const shortcuts: Shortcut[] = [
    {
        text: 'Aktivstes Ziel?',
        action: 'Was ist mein aktuell aktivstes Ziel?',
        highlighted: false,
        icon: 'target',
    },
    {
        text: 'Meine Superpowers',
        action: 'Meine Superpowers (Top 3 Skills)',
        highlighted: false,
        icon: 'sparkles',
    },
    {
        text: 'Lernpfad erstellen',
        action: 'Neuer Lernpfad erstellen',
        highlighted: false,
        icon: 'graduation-cap',
    },
    {
        text: 'Ähnliche Mitarbeitende',
        action: 'Ähnliche Mitarbeitende ansehen',
        highlighted: false,
        icon: 'users',
    },
    {
        text: 'Report generieren',
        action: 'Generiere eine Report meiner letzten Entwicklungen im Unternehmen.',
        highlighted: false,
        icon: 'file-chart-column-increasing',
    },
];

// Highlighted shortcut
export const highlightedShortcut: Shortcut = {
    text: 'Mini-Quiz',
    action: 'Hier eine Frage zu deinem TopSkill: Wie würdest du deine Expertise in deinem Top-Skill verbessern?',
    highlighted: true,
};

// Agent Actions
export const agentActions: AgentAction[] = [
    {
        id: '1',
        title: 'Zertifizierung planen',
        description: 'Erstelle einen Zeitplan für deine nächste Zertifizierung',
        actionText: 'Ich möchte eine Zertifizierung planen. Welche Schritte sind notwendig?',
    },
    {
        id: '2',
        title: 'Meeting mit Teamleitung buchen',
        description: 'Plane ein Gespräch zur Besprechung deiner Karriereziele',
        actionText: 'Ich möchte ein Meeting mit meiner Teamleitung buchen, um meine Karriereziele zu besprechen.',
    },
    {
        id: '3',
        title: 'Lernziel festlegen',
        description: 'Definiere dein nächstes Lernziel für dieses Quartal',
        actionText: 'Hilf mir, ein Lernziel für dieses Quartal zu definieren.',
    },
];

// UI Text Constants
export const uiTexts = {
    chatTitle: 'T4LO',
    chatSubtitle: 'Dein smarter Begleiter',
    deleteChat: 'Chat löschen',
};
